import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Flex } from '../../ui';
import { media } from '../../utils/media';

const RowModules = styled(Flex)` 
  ${media.lessThan('laptop')} {
    flex-direction:${({$isNotesOpen})=> $isNotesOpen && 'column'};
  }
  ${media.lessThan('bigTablet')} {
    flex-direction:column;
  }

  //hide empty components so we dont have extra empty space
  &:empty{
    display:none;
  }
`;

const ModuleGridContainer = styled.div`
  display: inline-grid;
  grid-template-columns: ${({$columns})=> $columns === 3 ? '32% 32% 32%' : '49% 49%'};
  overflow: auto;
  width: 100%;
  justify-content: space-between;
  align-items: start;

  ${media.lessThan('bigTablet')} {
    grid-template-columns: repeat(1, 98%);
    grid-gap: 25px;
  }
`;

/**
 * Row component - Renders a single row of course modules
 * 
 * @param {Object} props
 * @param {Object} props.pageRow - The page row data containing modules
 * @param {boolean} props.isNotesOpen - Whether notes panel is open (affects layout on mobile)
 * @param {Function} props.renderModule - Function to render individual modules
 * @param {Object} props.moduleProps - Additional props to pass to each module
 * @returns {JSX.Element}
 */
const Row = ({ pageRow, isNotesOpen, renderModule, moduleProps = {} }) => {
  const pageModulesLength = pageRow.pageModules.length;
  const ModuleContainer = pageModulesLength < 2 ? Fragment : ModuleGridContainer;
  const containerProps = pageModulesLength > 1 ? { $columns: pageModulesLength } : {};
  
  return (
    <RowModules 
      $isNotesOpen={isNotesOpen} 
      gap="20" 
      width="100%" 
      key={`pageRow-${pageRow.id}`} 
      justify={pageModulesLength < 2 ? 'center' : "space-between"} 
      align="flex-start"
    >
      <ModuleContainer {...containerProps}>
        {pageRow.pageModules.map(module => 
          renderModule(module, { 
            ...moduleProps, 
            $columns: pageModulesLength,
            key: `pageModules-${module.id}` 
          })
        )}
      </ModuleContainer>
    </RowModules>
  );
};

export default Row;

